<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { offersApprenticeships } from '$lib/stores/selection';
</script>

<!--
  Not part of ContactFilters, although it is one more checkbox.

  That component asks whether we hold a way of reaching a company — website,
  e-mail, phone, four social profiles. This asks something about the company
  itself. Put in that grid it would read as an eighth channel, and "Kanäle:
  Website, E-Mail, Lehrbetrieb" is a sentence that means nothing.

  # It had a guided step and does not any more

  There was a `StepApprenticeships` in the wizard, between legal form and
  channels, carrying an `embedded` variant of this control. Removed on
  2026-09-30: a door is four or five questions that most customers answer, and
  giving one of the narrowest filters in the product a screen of its own put it
  on a level with region and industry. It lives in the sidebar, where a
  customer who wants it goes looking for it.

  What went with it is the room to explain the filter's blind spot, which is why
  that sentence is now the label's `title` rather than a paragraph. See below.
-->
<div class="p-3">
  <!--
    The caveat is on the control, not in a paragraph beside it.

    Ticking this quietly drops every company we have not crawled and hold
    nobody for, and the result looks like a small industry rather than a partial
    view of a large one — a customer reading the count afterwards cannot tell
    those apart. A `title` is a weak place for it and it is the honest fit for a
    320px rail: the sentence exists and is reachable, without this filter taking
    three lines in a panel where region takes one.
  -->
  <label
    class="group flex cursor-pointer items-start"
    title={$_('filters.apprenticeships.explain')}
  >
    <input
      type="checkbox"
      bind:checked={$offersApprenticeships}
      class="mr-2 mt-0.5 h-3 w-3 shrink-0 rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200"
    />
    <svg class="filter-mark mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 14l9-5-9-5-9 5 9 5z"
      />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 14l6.16-3.422A12.083 12.083 0 0112 21.5a12.083 12.083 0 01-6.16-10.922L12 14z"
      />
    </svg>

    <span class="min-w-0">
      <span
        class="block text-xs font-semibold text-gray-900 transition-colors group-hover:text-gray-700"
      >
        {$_('filters.apprenticeships.label')}
      </span>
      <span class="mt-0.5 block text-2xs text-gray-500">
        {$_('filters.apprenticeships.hint')}
      </span>
    </span>
  </label>
</div>
